module.exports = __webpack_public_path__ + "static/img/faq_service03.944bb4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/faq_service03.png
// module id = rAM3
// module chunks = 2